export default {
  title: 'Redenumește oferta',
  subtitle: 'Introduceți un nume nou pentru ofertă (maximum 40 de caractere)',
  toasts: {
    success: 'Ofertă redenumită cu succes',
    error: 'Redenumirea ofertei a eșuat',
  },
  buttons: {
    rename: 'Redenumește',
  },
  form: {
    title: {
      label: 'Numele ofertei',
      placeholder: 'Introduceți numele ofertei',
    },
  },
};
